import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PopupForm from "./components/PopupForm";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ServicePage from "./pages/ServicePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import LandingPage from "./pages/LandingPage";
import ApplicationMain from "./pages/ApplicationMain";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar onOpenPopup={() => setIsPopupOpen(true)} />
          <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
          <Routes>
            <Route path="/" element={<Home onOpenPopup={() => setIsPopupOpen(true)} />} />
            <Route path="/about" element={<About onOpenPopup={() => setIsPopupOpen(true)} />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services/:slug" element={<ServicePage onOpenPopup={() => setIsPopupOpen(true)} />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/lp" element={<LandingPage />} />
            <Route path="/application/main" element={<ApplicationMain />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
